(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("miseRouter", [], factory);
	else if(typeof exports === 'object')
		exports["miseRouter"] = factory();
	else
		root["miseRouter"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _link = __webpack_require__(1);

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function get() {
    return _link.Link;
  }
});

var _redirect = __webpack_require__(3);

Object.defineProperty(exports, 'Redirect', {
  enumerable: true,
  get: function get() {
    return _redirect.Redirect;
  }
});

var _route = __webpack_require__(4);

Object.defineProperty(exports, 'Route', {
  enumerable: true,
  get: function get() {
    return _route.Route;
  }
});

var _switch = __webpack_require__(7);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _switch.Switch;
  }
});

var _init = __webpack_require__(8);

Object.defineProperty(exports, 'init', {
  enumerable: true,
  get: function get() {
    return _init.init;
  }
});

var _action = __webpack_require__(9);

Object.defineProperty(exports, 'commisRouteUpdateAction', {
  enumerable: true,
  get: function get() {
    return _action.commisRouteUpdateAction;
  }
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(2);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Link = function Link(_ref, children) {
  var _ref$to = _ref.to,
      to = _ref$to === undefined ? '#' : _ref$to,
      _ref$state = _ref.state,
      state = _ref$state === undefined ? {} : _ref$state,
      rest = _objectWithoutProperties(_ref, ['to', 'state']);

  return (0, _core.dom)('a', _extends({
    href: to
  }, rest, {
    onclick: function onclick(e) {
      e.preventDefault();

      if (window.location.pathname !== to) {
        window.history.pushState(state, '', to);
        document.dispatchEvent(new Event('somm-pushstate'));
      }

      if (rest.onclick) rest.onclick(e);
    }
  }), children);
};

exports.Link = Link;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("mise",[],t):"object"==typeof exports?exports.mise=t():e.mise=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.types=t.create=void 0;var n=r(1),o={create:"CREATE",remove:"REMOVE",replace:"REPLACE",update:"UPDATE",skip:"SKIP"},i=function(e){var t=e.parent,r=e.element,o=void 0===r?null:r,i=e.previous,a=void 0===i?null:i,u=e.next,c=void 0===u?null:u;return{parent:t,previous:{tree:a,element:o},next:{tree:c,element:null!==c?(0,n.createElement)(c):c}}};t.create=i,t.types=o},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.createElement=t.paint=void 0;var n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},o=r(2),i=r(0),a=function(e,t,r,i){if(void 0===i||!1===i||"object"===(void 0===i?"undefined":n(i))&&!Object.keys(i).length)return void e.removeAttribute(t);if("style"===t){var a=(0,o.getUniques)(i,r),u=!0,c=!1,l=void 0;try{for(var f,p=a[Symbol.iterator]();!(u=(f=p.next()).done);u=!0){var s=f.value;i[s]?r&&r[s]&&r[s]===i[s]||(e.style[s]=i[s]):e.style[s]=""}}catch(e){c=!0,l=e}finally{try{!u&&p.return&&p.return()}finally{if(c)throw l}}}else{try{e[t]=i}catch(e){}"function"!=typeof i&&"value"!==t&&"boolean"!==t&&e.setAttribute(t,i)}},u=function(e,t,r){var n=(0,o.getUniques)(t,r),i=!0,u=!1,c=void 0;try{for(var l,f=n[Symbol.iterator]();!(i=(l=f.next()).done);i=!0){var p=l.value;a(e,p,t[p],r[p])}}catch(e){u=!0,c=e}finally{try{!i&&f.return&&f.return()}finally{if(u)throw c}}},c=function e(t){if(null===t)return!1;if("string"==typeof t)return document.createTextNode(t);var r=t.type,n=t.props,o=t.children,i=document.createElement(r);return u(i,{},n),o.map(e).forEach(function(e){return e&&i.appendChild(e)}),i},l=function(e){var t=!0,r=!1,n=void 0;try{for(var o,a=e[Symbol.iterator]();!(t=(o=a.next()).done);t=!0){var c=o.value,l=c.action,f=c.next,p=c.previous,s=c.lifecycle,y=c.parent;switch(l){case i.types.create:null===p.tree?y.insertBefore(f.element,p.element):y.appendChild(f.element),s&&s(f.element);break;case i.types.remove:s?s(f.element)(p.element.remove.bind(p.element)):p.element.remove();break;case i.types.replace:s&&s(f.element)(p.props),y.replaceChild(f.element,p.element);break;case i.types.update:s&&s(f.element)(p.props),u(p.element,p.tree.props,f.tree.props);break;default:return}}}catch(e){r=!0,n=e}finally{try{!t&&a.return&&a.return()}finally{if(r)throw n}}};t.paint=l,t.createElement=c},function(e,t,r){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},i=function(e,t){return new Set([].concat(n(Object.keys(e||{})),n(Object.keys(t||{}))))},a=function(){for(var e=arguments.length,t=Array(e),r=0;r<e;r++)t[r]=arguments[r];return t&&t.length?1===t.length?t[0]:t.reduce(function(e,t){return function(){return e(t.apply(void 0,arguments))}}):function(e){return e}},u=function(e){return Array.isArray(e)?[].concat(n(e)):o({},e)};t.getUniques=i,t.compose=a,t.makeCopy=u},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=r(4);Object.defineProperty(t,"component",{enumerable:!0,get:function(){return n.component}});var o=r(6);Object.defineProperty(t,"dom",{enumerable:!0,get:function(){return o.dom}})},function(e,t,r){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.component=void 0;var o=function(){function e(e,t){var r=[],n=!0,o=!1,i=void 0;try{for(var a,u=e[Symbol.iterator]();!(n=(a=u.next()).done)&&(r.push(a.value),!t||r.length!==t);n=!0);}catch(e){o=!0,i=e}finally{try{!n&&u.return&&u.return()}finally{if(o)throw i}}return r}return function(t,r){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},a=r(5),u=r(0),c=r(2),l=function(e){var t=e.template,r=e.state,l=e.actions,f=e.root,p=void 0===f?document.body:f,s=e.middleware,y=void 0===s?[]:s,v=e.init,d=(0,a.reconciler)(),m=d.add,b=void 0,h=void 0,g=void 0,x=function(e){return function(r){var n=(0,c.makeCopy)(e),o=(0,c.makeCopy)(r);return t(n)(o)}},A=function(){var e=b;b=x(h)(g);var t=(0,u.create)({parent:p,element:p.childNodes[0],previous:e,next:b});m(t)},O=function(e){h=i({},h,e),A()},j=function(e){var t={},r=!0,i=!1,a=void 0;try{for(var u,l=Object.entries(e)[Symbol.iterator]();!(r=(u=l.next()).done);r=!0){var f=u.value,p=o(f,2),s=p[0],v=p[1];!function(e,r){t[e]=function(t){var o=(0,c.makeCopy)(h),i=(0,c.makeCopy)(g),a=r.bind(null,o,i),u=y.map(function(t){return t(o)(e)}),l=c.compose.apply(void 0,n(u))(a),f=l(t);"function"==typeof f?f(O):O(f)}}(s,v)}}catch(e){i=!0,a=e}finally{try{!r&&l.return&&l.return()}finally{if(i)throw a}}return t};!function(e){h=r,g=j(e);var t=(0,c.makeCopy)(h),n=(0,c.makeCopy)(g);v&&v(t)(n),b=x(h)(g);var o=(0,u.create)({parent:p,next:b});m(o)}(l)};t.component=l},function(e,t,r){"use strict";function n(e){return Array.isArray(e)?e:Array.from(e)}function o(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.reconciler=void 0;var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=r(0),c=r(1),l=function(e,t){return(void 0===e?"undefined":a(e))!==(void 0===t?"undefined":a(t))||"string"==typeof e&&e!==t||e.type!==t.type},f=function(e){var t=[],r=e.previous.tree&&e.previous.tree.children||[],n=e.next.tree&&e.next.tree.children||[],i=Math.max(r.length,n.length);if(e.previous.element)for(var a=0;a<i;a+=1){var c=(0,u.create)({parent:e.previous.element,element:e.previous.element&&e.previous.element.childNodes[a]||null,previous:r[a],next:n[a]});t=[].concat(o(t),[c])}return t},p=function(e){var t=i({},e);return null===t.previous.tree&&null===t.next.tree?(t.action=u.types.skip,t):t.previous.tree?t.next.tree?l(t.previous.tree,t.next.tree)?(t.action=u.types.replace,t.next.tree.props&&t.next.tree.props.onupdate&&(t.lifecycle=t.next.tree.props.onupdate),t):(t.action=u.types.update,t.next.tree.props&&t.next.tree.props.onupdate&&(t.lifecycle=t.next.tree.props.onupdate),t):(t.action=u.types.remove,t.previous.tree.props&&t.previous.tree.props.onremove&&(t.lifecycle=t.previous.tree.props.onremove),t):(t.action=u.types.create,t.next.tree.props&&t.next.tree.props.oncreate&&(t.lifecycle=t.next.tree.props.oncreate),t)},s=function(){var e=!1,t=[],r=[],i=function(){var e=t,r=n(e),o=r[0],i=r.slice(1);return t=i,o},a=function(e){for(;e.timeRemaining()&&t.length;){var n=i(),a=p(n);if(a.action!==u.types.skip){var c=f(n);c.length&&c.forEach(s),r=[].concat(o(r),[a])}}},l=function n(i){if(a(i),t.length)requestIdleCallback(n);else{e=!1;var u=[].concat(o(r));requestAnimationFrame(function(){return(0,c.paint)(u)}),r=[]}},s=function(r){t=[].concat(o(t),[r]),e||(e=!0,requestIdleCallback(l))};return{add:s}};t.reconciler=s},function(e,t,r){"use strict";function n(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=function(e){for(var t=arguments.length,r=Array(t>2?t-2:0),o=2;o<t;o++)r[o-2]=arguments[o];var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},a=[],u=i,c=!0,l=!1,f=void 0;try{for(var p,s=r[Symbol.iterator]();!(c=(p=s.next()).done);c=!0){var y=p.value;a=Array.isArray(y)?[].concat(n(a),n(y)):[].concat(n(a),["number"==typeof y?String(y):y])}}catch(e){l=!0,f=e}finally{try{!c&&s.return&&s.return()}finally{if(l)throw f}}return null===i&&(u={}),u.className&&(u.class=u.className,u.className=void 0),"function"==typeof e?e(u,a):{type:e,props:u,children:a}};t.dom=o}])});
//# sourceMappingURL=mise.js.map

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Redirect = function Redirect(_ref) {
  var to = _ref.to,
      when = _ref.when,
      state = _ref.state;

  var conditional = typeof when === 'function' ? when() : when;

  if (conditional) {
    window.history.replaceState(state, '', to);
  }
};

exports.Redirect = Redirect;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Route = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(5);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Route = function Route(_ref) {
  var path = _ref.path,
      template = _ref.template,
      exact = _ref.exact,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      props = _objectWithoutProperties(_ref, ['path', 'template', 'exact', 'sensitive', 'strict']);

  var result = (0, _utils.match)({
    current: window.location.pathname,
    path: path,
    exact: exact,
    sensitive: sensitive,
    strict: strict
  });

  if (result.match) {
    return template(_extends({ match: result.props }, props));
  }

  return null;
};

exports.Route = Route;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _pathToRegexp = __webpack_require__(6);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var match = function match(_ref) {
  var _ref$path = _ref.path,
      path = _ref$path === undefined ? '/' : _ref$path,
      current = _ref.current,
      options = _objectWithoutProperties(_ref, ['path', 'current']);

  var result = { match: false };

  var keys = [];
  var optionsWithDefaults = _extends({
    strict: false,
    sensitive: false
  }, options, {
    end: options.exact || false
  });

  var regex = (0, _pathToRegexp2.default)(path, keys, optionsWithDefaults);
  var matched = regex.exec(current);

  if (!matched) {
    return result;
  }

  var _matched = _toArray(matched),
      url = _matched[0],
      values = _matched.slice(1);

  var exact = url === current;

  if (options.exact && !exact) {
    return result;
  }

  var params = keys.reduce(function (collection, key, index) {
    collection[key.name] = values[index];
    return collection;
  }, {});

  return {
    match: true,
    props: {
      path: path,
      url: url,
      exact: exact,
      params: params
    }
  };
};

exports.match = match;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * Default configs.
 */
var DEFAULT_DELIMITER = '/'
var DEFAULT_DELIMITERS = './'

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?"]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined]
  '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = (options && options.delimiter) || DEFAULT_DELIMITER
  var delimiters = (options && options.delimiters) || DEFAULT_DELIMITERS
  var pathEscaped = false
  var res

  while ((res = PATH_REGEXP.exec(str)) !== null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      pathEscaped = true
      continue
    }

    var prev = ''
    var next = str[index]
    var name = res[2]
    var capture = res[3]
    var group = res[4]
    var modifier = res[5]

    if (!pathEscaped && path.length) {
      var k = path.length - 1

      if (delimiters.indexOf(path[k]) > -1) {
        prev = path[k]
        path = path.slice(0, k)
      }
    }

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
      pathEscaped = false
    }

    var partial = prev !== '' && next !== undefined && next !== prev
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prev || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prev,
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      pattern: pattern ? escapeGroup(pattern) : '[^' + escapeString(delimiter) + ']+?'
    })
  }

  // Push any remaining characters.
  if (path || index < str.length) {
    tokens.push(path + str.substr(index))
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (data, options) {
    var path = ''
    var encode = (options && options.encode) || encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token
        continue
      }

      var value = data ? data[token.name] : undefined
      var segment

      if (Array.isArray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but got array')
        }

        if (value.length === 0) {
          if (token.optional) continue

          throw new TypeError('Expected "' + token.name + '" to not be empty')
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        segment = encode(String(value))

        if (!matches[i].test(segment)) {
          throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"')
        }

        path += token.prefix + segment
        continue
      }

      if (token.optional) {
        // Prepend partial segment prefixes.
        if (token.partial) path += token.prefix

        continue
      }

      throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'))
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$/()])/g, '\\$1')
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  if (!keys) return path

  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        pattern: null
      })
    }
  }

  return path
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  return new RegExp('(?:' + parts.join('|') + ')', flags(options))
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var delimiter = escapeString(options.delimiter || DEFAULT_DELIMITER)
  var delimiters = options.delimiters || DEFAULT_DELIMITERS
  var endsWith = [].concat(options.endsWith || []).map(escapeString).concat('$').join('|')
  var route = ''
  var isEndDelimited = false

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
      isEndDelimited = i === tokens.length - 1 && delimiters.indexOf(token[token.length - 1]) > -1
    } else {
      var prefix = escapeString(token.prefix)
      var capture = token.repeat
        ? '(?:' + token.pattern + ')(?:' + prefix + '(?:' + token.pattern + '))*'
        : token.pattern

      if (keys) keys.push(token)

      if (token.optional) {
        if (token.partial) {
          route += prefix + '(' + capture + ')?'
        } else {
          route += '(?:' + prefix + '(' + capture + '))?'
        }
      } else {
        route += prefix + '(' + capture + ')'
      }
    }
  }

  if (end) {
    if (!strict) route += '(?:' + delimiter + ')?'

    route += endsWith === '$' ? '$' : '(?=' + endsWith + ')'
  } else {
    if (!strict) route += '(?:' + delimiter + '(?=' + endsWith + '))?'
    if (!isEndDelimited) route += '(?=' + delimiter + '|' + endsWith + ')'
  }

  return new RegExp('^' + route, flags(options))
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (path instanceof RegExp) {
    return regexpToRegexp(path, keys)
  }

  if (Array.isArray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), keys, options)
  }

  return stringToRegexp(/** @type {string} */ (path), keys, options)
}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Switch = function Switch(props, children) {
  return children.find(function (child) {
    return Boolean(child);
  });
};

exports.Switch = Switch;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var init = function init() {
  return function (actions) {
    document.addEventListener('somm-pushstate', actions.commisRouteUpdateAction);
    window.onpopstate = actions.commisRouteUpdateAction;
  };
};

exports.init = init;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var commisRouteUpdateAction = function commisRouteUpdateAction() {
  return {};
};

exports.commisRouteUpdateAction = commisRouteUpdateAction;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// mise-router.js